module.exports = __webpack_public_path__ + "../resources/img/ic_re_arrow_left_default.0eb08d3d.svg";